/* Jo's PokeStop: product cards for items with several versions (Choose options) fade through the product's photos.
   Works on the homepage shelves (.jp-item) and on collection, search and recommendation cards (.product-card).
   Photos load only when a card scrolls into view. Cycling stops off-screen and is skipped when the
   visitor has asked for reduced motion. */
(function(){
  if (window.josCardImages) return;
  window.josCardImages = true;
  var INTERVAL = 2200, MAX_IMAGES = 6, cache = {};
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var css = document.createElement('style');
  css.textContent =
    '.jos-cycle{position:absolute;inset:0;z-index:0;display:block;background:#fff;pointer-events:none;border-radius:inherit;overflow:hidden}' +
    '.jos-cycle img{position:absolute;inset:0;width:100%;height:100%;padding:10px;object-fit:contain;opacity:0;transition:opacity .45s ease}' +
    '.jos-cycle img.is-on{opacity:1}' +
    '.jos-cycle-dots{position:absolute;left:0;right:0;bottom:6px;z-index:1;display:flex;justify-content:center;gap:5px;pointer-events:none}' +
    '.jos-cycle-dots i{width:7px;height:7px;border:1.5px solid #0d0f14;border-radius:50%;background:#fff}' +
    '.jos-cycle-dots i.is-on{background:#ffd23f}' +
    '.product-card__image-holder.jos-has-cycle .btn-quickview,.product-card__image-holder.jos-has-cycle modal-opener{z-index:2}';
  document.head.appendChild(css);

  function hasOptions(card){
    return !!card.querySelector('a.jp-item-add, modal-opener .btn--add-to-cart');
  }
  function handleOf(card){
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }
  function frameOf(card){
    return card.querySelector('.jp-item-image') || card.querySelector('.product-card__image-holder');
  }
  function sized(src){
    if (!src) return null;
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=500';
  }
  function load(handle){
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + handle + '.js', {credentials: 'same-origin'})
        .then(function(r){ return r.ok ? r.json() : null; })
        .catch(function(){ return null; });
    }
    return cache[handle];
  }

  function build(card){
    var handle = handleOf(card), frame = frameOf(card);
    if (!handle || !frame) return;
    load(handle).then(function(p){
      if (!p || !p.variants || p.variants.length < 2 || !p.images || p.images.length < 2) return;
      var urls = p.images.slice(0, MAX_IMAGES).map(sized);
      var layer = document.createElement('span');
      layer.className = 'jos-cycle';
      layer.setAttribute('aria-hidden', 'true');
      var dots = document.createElement('span');
      dots.className = 'jos-cycle-dots';
      urls.forEach(function(u, i){
        var img = document.createElement('img');
        img.alt = ''; img.loading = 'lazy'; img.decoding = 'async'; img.src = u;
        if (i === 0) img.className = 'is-on';
        layer.appendChild(img);
        var d = document.createElement('i');
        if (i === 0) d.className = 'is-on';
        dots.appendChild(d);
      });
      if (getComputedStyle(frame).position === 'static') frame.style.position = 'relative';
      frame.appendChild(layer);
      frame.appendChild(dots);
      frame.classList.add('jos-has-cycle');
      card._josCycle = {imgs: layer.children, dots: dots.children, i: 0, timer: null};
      if (card._josVisible) start(card);
    });
  }
  function step(card){
    var c = card._josCycle; if (!c) return;
    var n = c.imgs.length;
    c.imgs[c.i].classList.remove('is-on'); c.dots[c.i].classList.remove('is-on');
    c.i = (c.i + 1) % n;
    c.imgs[c.i].classList.add('is-on'); c.dots[c.i].classList.add('is-on');
  }
  function start(card){
    var c = card._josCycle;
    if (!c || c.timer || reduce) return;
    c.timer = setInterval(function(){ if (!document.hidden) step(card); }, INTERVAL);
  }
  function stop(card){
    var c = card._josCycle;
    if (c && c.timer) { clearInterval(c.timer); c.timer = null; }
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      var card = e.target;
      card._josVisible = e.isIntersecting;
      if (e.isIntersecting) {
        if (!card._josBuilt) { card._josBuilt = true; build(card); }
        start(card);
      } else {
        stop(card);
      }
    });
  }, {rootMargin: '200px 0px'}) : null;

  function scan(root){
    if (!io) return;
    (root || document).querySelectorAll('.jp-item, .product-card').forEach(function(card){
      if (card._josWatched || !hasOptions(card)) return;
      card._josWatched = true;
      io.observe(card);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ scan(); });
  else scan();
  /* Filtering, sorting and paging on collection pages swap the product grid in place */
  var pending = null;
  new MutationObserver(function(){
    if (pending) return;
    pending = setTimeout(function(){ pending = null; scan(); }, 400);
  }).observe(document.body || document.documentElement, {childList: true, subtree: true});
})();
